export class ReprocessLogModel {
  id!: number;

  userId!: string;

  startDate!: string; // ISO date string

  endDate!: string; // ISO date string

  totalFound!: number;

  successCount!: number;

  failureCount!: number;

  updateDate!: string; // ISO datetime string

  insertDate!: string; // ISO datetime string
}
